import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthLayout from "@/components/auth/AuthLayout";
import { useAuth } from "@/contexts/AuthContext";

const Login = () => {
  const { login, formatApiErrorDetail } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email.trim(), password);
      toast.success(`Welcome back, ${u.name.split(" ")[0]}`);
      nav(u.onboarded ? "/app/discover" : "/onboarding");
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  const useTestUser = () => {
    setEmail("test@swolemates.app");
    setPassword("TestPass123!");
  };

  return (
    <AuthLayout
      title={<>Welcome <span className="text-[#C6FF00]">Back.</span></>}
      subtitle="Sign In"
      footer={
        <>
          New here?{" "}
          <Link to="/register" className="text-[#C6FF00] font-semibold" data-testid="login-go-register">
            Create an account
          </Link>
        </>
      }
    >
      <form onSubmit={submit} className="flex flex-col gap-4" data-testid="login-form">
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-neutral-400 font-semibold block mb-2">
            Email
          </label>
          <input
            data-testid="login-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-[#111] border border-white/10 rounded-md px-4 py-3 text-white placeholder:text-neutral-600 focus:outline-none focus:border-[#C6FF00] transition-colors"
            placeholder="you@gymrat.com"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-neutral-400 font-semibold block mb-2">
            Password
          </label>
          <input
            data-testid="login-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-[#111] border border-white/10 rounded-md px-4 py-3 text-white placeholder:text-neutral-600 focus:outline-none focus:border-[#C6FF00] transition-colors"
            placeholder="••••••••"
          />
        </div>
        <button
          data-testid="login-submit"
          type="submit"
          disabled={loading}
          className="mt-2 bg-[#C6FF00] hover:bg-[#AEE600] text-[#0A0A0A] font-bold text-sm uppercase tracking-[0.25em] px-6 py-4 rounded-md transition-all disabled:opacity-60 hover:scale-[1.02] shadow-[0_0_20px_rgba(198,255,0,0.25)]"
        >
          {loading ? "Signing in…" : "Sign In"}
        </button>
        <button
          data-testid="login-test-user"
          type="button"
          onClick={useTestUser}
          className="text-xs uppercase tracking-[0.2em] text-neutral-500 hover:text-[#C6FF00] font-semibold py-2"
        >
          Use demo test account →
        </button>
      </form>
    </AuthLayout>
  );
};

export default Login;
